import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'verify-email',
  async getComponent (nextState) {
    const {
      default: VerifyEmailContainer
    } = await import(/* webpackChunkName: "verify-email-contianer" */ './containers/VerifyEmailContainer')
      .catch(handleChunkLoadError);
    return VerifyEmailContainer;
  },
  children: [
    {
      path: '',
      async getComponent (nextState) {
        const {
          default: VerifyEmailPage
        } = await import(/* webpackChunkName: "verify-email-page" */ './containers/VerifyEmailPage')
          .catch(handleChunkLoadError);
        return VerifyEmailPage;
      },
      getData ({ context: { props } }) {
        return props;
      }
    },
    {
      path: 'token/:token',
      async getComponent (nextState) {
        const {
          default: VerifyEmailTokenPage
        } = await import(/* webpackChunkName: "verify-email-page-token" */ './containers/VerifyEmailTokenPage')
          .catch(handleChunkLoadError);
        return VerifyEmailTokenPage;
      },
      getData ({ context: { props } }) {
        return props;
      }
    }
  ]
});
